import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {DxPopupModule, DxButtonModule, DxButtonGroupModule, DxFormModule, DxTextAreaModule, DxNumberBoxModule, DxSelectBoxModule, DxCheckBoxModule, DxScrollViewModule, DxTextBoxModule} from 'devextreme-angular';
import {ValidateDialogComponent} from './validate-dialog/validate-dialog.component';
import {RejectDialogComponent} from './reject-dialog/reject-dialog.component';

@NgModule({
  declarations: [
    ValidateDialogComponent,
    RejectDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    DxPopupModule,
    DxButtonModule,
    DxButtonGroupModule,
    DxFormModule,
    DxTextAreaModule,
    DxNumberBoxModule,
    DxSelectBoxModule,
    DxCheckBoxModule,
    DxScrollViewModule,
    DxTextBoxModule
  ],
  exports: [
    ValidateDialogComponent,
    RejectDialogComponent
  ]
})
export class DialogsModule {
}

